import { defineComponent, h } from 'vue';
import { Modal } from '@/ui/components/Modal';
import { col, cols } from '@/ui/components';
import { Button } from '@/ui/components/Button';
import { CheckboxList, CheckboxListResource, Type } from '@/ui/components/CheckboxList';
import { t } from '@/ui/i18n/i18n';

interface FreeTrialStartsModalProps {
  active: boolean;
  loading: boolean;
}

export const FreeTrialPreviewModal = defineComponent<FreeTrialStartsModalProps>({
  props: ['active', 'loading'],
  setup(props, context) {
    const onStartTrialClick = () => {
      context.emit('start-trial:click');
    };
    const onModalClose = () => {
      context.emit('close');
    };
    const checkboxListResources: CheckboxListResource[] = [
      { type: Type.Included, text: t('free-trial-modal.checklist.unlimited-inspections') },
      { type: Type.Included, text: t('free-trial-modal.checklist.unlimited-user-seats') },
      { type: Type.Included, text: t('free-trial-modal.checklist.analytics') },
      { type: Type.Included, text: t('free-trial-modal.checklist.permission-management') },
      { type: Type.Included, text: t('free-trial-modal.checklist.report-customization') },
      { type: Type.Included, text: t('free-trial-modal.checklist.scores') },
      { type: Type.Included, text: t('free-trial-modal.checklist.categories-tags-labels') },
      { type: Type.Included, text: t('free-trial-modal.checklist.individual-templates') },
      { type: Type.Included, text: t('free-trial-modal.checklist.notifications') },
      { type: Type.Included, text: t('free-trial-modal.checklist.export') },
    ];

    return function render() {
      const firstColumn = () => col([
        context.slots.title
          ? h('div', { class: 'free-trial-starts-modal__welcome' }, context.slots.title())
          : null,
        context.slots.subTitle?.(),
        h('div', { class: 'mb-4' }, t('free-trial-modal.will-uncover')),
        h(CheckboxList, { props: { list: checkboxListResources, shadowed: true } }),
        h(Button, {
          props: {
            btnClass: 'free-trial-starts-modal__btn',
            loading: props.loading,
          },
          nativeOn: {
            click: onStartTrialClick,
          },
        }, [
          context.slots.ctaText?.() || t('free-trial-modal.start'),
        ]),
        h('div', { class: 'free-trial-starts-modal__explanation' }, [
          context.slots.explanation?.(),
        ]),
      ], false, { 'is-7 free-trial-starts-modal__first-column': true });
      const secondColumn = () => col([
        h('img', {
          attrs: {
            class: 'free-trial-starts-modal__img',
            src: '/images/Illustration for free trial popup.svg',
          },
        }),
      ], false, { 'free-trial-starts-modal__second-column': true });

      return h(Modal, {
        props: {
          active: props.active,
          customClass: 'free-trial-starts-modal',
          canCancel: ['x'],
        },
        on: {
          close: onModalClose,
        },
      }, [
        cols([
          firstColumn(),
          secondColumn(),
        ]),
      ]);
    };
  },
});
